module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 p-2 min-h-screen"
  }, [_c('h3', {
    staticClass: "font-bold mb-3 text-gray-700 text-center"
  }, [(!_vm._id) ? _c('span', [_vm._v("Nueva ")]) : _vm._e(), (_vm.copiando) ? _c('span', [_vm._v("Copiando ")]) : _vm._e(), _c('span', [_vm._v("Cirugía")]), (_vm._id) ? _c('div', [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Creado " + _vm._s(_vm._f("fromNow")(_vm.fechaCreacion)))])]) : _vm._e(), (_vm.copiando) ? _c('div', [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Copiando cirugía, haga los cambios necesarios y presione guardar")])]) : _vm._e()]), _c('transition-group', {
    staticClass: "contenedor-transition-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "fecha",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fecha),
      expression: "fecha"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fecha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fecha = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "hora",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Hora")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hora),
      expression: "hora"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.hora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hora = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "doctor",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Doctor")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreDoctor),
      expression: "nombreDoctor"
    }],
    ref: "doctor",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.nombreDoctor)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverDoctor = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverDoctor = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverDoctor = true
      }],
      "click": function($event) {
        _vm.showPopoverDoctor = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreDoctor = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-md text-gray-500"
  })]), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverDoctor = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverDoctor) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverDoctor = false
      }
    }
  }, [_c('doctor-seleccionar', {
    on: {
      "selected": _vm.seleccionarDoctor,
      "close": _vm.cerrarDoctor
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "clinica",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Clínica")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionClinica),
      expression: "descripcionClinica"
    }],
    ref: "clinica",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionClinica)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverClinica = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverClinica = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverClinica = true
      }],
      "click": function($event) {
        _vm.showPopoverClinica = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionClinica = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-hospital text-gray-500"
  })]), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverClinica = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverClinica) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverClinica = false
      }
    }
  }, [_c('clinica-seleccionar', {
    on: {
      "selected": _vm.seleccionarClinica,
      "close": _vm.cerrarClinica
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "tipo-cirugia",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo cirugía")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionTipoCirugia),
      expression: "descripcionTipoCirugia"
    }],
    ref: "tipoCirugia",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionTipoCirugia)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }],
      "click": function($event) {
        _vm.showPopoverTipoCirugia = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionTipoCirugia = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-procedures text-gray-500"
  })]), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTipoCirugia = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTipoCirugia) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTipoCirugia = false
      }
    }
  }, [_c('tipo-cirugia-seleccionar', {
    on: {
      "selected": _vm.seleccionarTipoCirugia,
      "close": _vm.cerrarTipoCirugia
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "tecnico",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Técnico")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreTecnico),
      expression: "nombreTecnico"
    }],
    ref: "tecnico",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'tecnico'
    },
    domProps: {
      "value": (_vm.nombreTecnico)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTecnico = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTecnico = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTecnico = true
      }],
      "click": function($event) {
        _vm.showPopoverTecnico = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreTecnico = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-cog text-gray-500"
  })]), (_vm.perfil !== 'tecnico') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTecnico = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTecnico) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTecnico = false
      }
    }
  }, [_c('tecnico-seleccionar', {
    on: {
      "selected": _vm.seleccionarTecnico,
      "close": _vm.cerrarTecnico
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "enfermera",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Enfermera")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreEnfermera),
      expression: "nombreEnfermera"
    }],
    ref: "enfermera",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'enfermera'
    },
    domProps: {
      "value": (_vm.nombreEnfermera)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverEnfermera = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverEnfermera = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverEnfermera = true
      }],
      "click": function($event) {
        _vm.showPopoverEnfermera = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreEnfermera = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-nurse text-gray-500"
  })]), (_vm.perfil !== 'enfermera') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverEnfermera = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverEnfermera) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverEnfermera = false
      }
    }
  }, [_c('enfermera-seleccionar', {
    on: {
      "selected": _vm.seleccionarEnfermera,
      "close": _vm.cerrarEnfermera
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "tipo-cobro",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo cobro")]), _c('div', {
    staticClass: "flex w-full"
  }, [_c('div', {
    staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer",
    class: {
      'is-active': _vm.tipoCobro === 'particular'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'particular' ? '' : 'particular'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-money-bill text-gray-500"
  }), _c('span', [_vm._v("Particular")])]), _c('div', {
    staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer",
    class: {
      'is-active': _vm.tipoCobro === 'credito'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'credito' ? '' : 'credito'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-money-check text-gray-500"
  }), _c('span', [_vm._v("Crédito")])]), _c('div', {
    staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer",
    class: {
      'is-active': _vm.tipoCobro === 'transferencia'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'transferencia' ? '' : 'transferencia'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-hand-holding-usd text-gray-500"
  }), _c('span', [_vm._v("Transferencia")])])])])]), (_vm.tipoCobro === 'particular') ? _c('div', {
    key: "monto-cobrado",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("¿Cuánto ha cobrado?")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.montoCobrado),
      expression: "montoCobrado"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.montoCobrado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.montoCobrado = $event.target.value
      }
    }
  })])]) : _vm._e(), (_vm.tipoCobro === 'credito') ? _c('div', {
    key: "nombre-paciente",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Nombre del paciente")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombrePaciente),
      expression: "nombrePaciente"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nombrePaciente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombrePaciente = $event.target.value
      }
    }
  })])]) : _vm._e(), _c('div', {
    key: "clipsUtilizados",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Clips utilizados")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clipsUtilizados),
      expression: "clipsUtilizados"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.clipsUtilizados)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clipsUtilizados = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "numeroCaja",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Número de caja")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numeroCaja),
      expression: "numeroCaja"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.numeroCaja)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numeroCaja = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "grapas-container",
    staticClass: "p-2"
  }, [_c('div', {
    staticClass: "border-solid border-2 border-slate-300 p-2"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Grapas utilizadas")]), _c('transition-group', {
    staticClass: "contenedor-transition-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "g-1",
    staticClass: "flex w-full flex-wrap"
  }, _vm._l((_vm.listaMarcasGrapa), function(o) {
    return _c('div', {
      staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer text-center",
      class: {
        'is-active': _vm.codigoMarcaGrapa === o.codigo
      },
      on: {
        "click": function($event) {
          return _vm.seleccionarMarca(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcion))])])
  }), 0), (_vm.codigoMarcaGrapa !== '' && _vm.codigoMarcaGrapa !== 'doctorUtilizoSusGrapas') ? _c('div', {
    key: "g-2",
    staticClass: "p-2"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 text-xs pb-1"
  }, [_vm._v("Ingresa el numero de grapas utilizadas por color")]), _c('div', {
    staticClass: "flex w-full p-2 items-center"
  }, [_c('div', {
    staticClass: "bg-purple-500 rounded-full w-8 h-8"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grapasMoradas),
      expression: "grapasMoradas"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm ml-2",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.grapasMoradas)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grapasMoradas = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "flex w-full p-2 items-center"
  }, [_c('div', {
    staticClass: "bg-black rounded-full w-8 h-8"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grapasNegras),
      expression: "grapasNegras"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm ml-2 cursor-not-allowed",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.grapasNegras)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grapasNegras = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "flex w-full p-2 items-center"
  }, [_c('div', {
    staticClass: "bg-yellow-500 rounded-full w-8 h-8"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grapasDoradas),
      expression: "grapasDoradas"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm ml-2",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.grapasDoradas)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grapasDoradas = $event.target.value
      }
    }
  })])]) : _vm._e()])], 1)]), _c('div', {
    key: "comentario",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Comentario")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comentario),
      expression: "comentario"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    domProps: {
      "value": (_vm.comentario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comentario = $event.target.value
      }
    }
  })])]), (_vm.copiando) ? _c('div', {
    key: "copy-message",
    staticClass: "mb-3"
  }, [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Copiando cirugía, haga los cambios necesarios y presione guardar")])]) : _vm._e(), _c('div', {
    key: "acciones",
    staticClass: "flex mb-2 justify-center mb-20"
  }, [_c('div', {
    staticClass: "bg-primary text-sm flex items-center text-white py-2 px-4 rounded cursor-pointer",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Guardar")]), (_vm._id) ? _c('div', {
    staticClass: "text-primary text-sm flex items-center border-primary border py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.irANuevaCirugia
    }
  }, [_vm._v("Nueva cirugía")]) : _vm._e(), (_vm._id && _vm.copiando === false) ? _c('div', {
    staticClass: "bg-primary text-sm flex items-center text-white py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Duplicar")]) : _vm._e(), (_vm.perfil === 'administrador' && _vm._id && !_vm.copiando) ? _c('div', {
    staticClass: "bg-red-500 text-sm flex items-center text-white py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Eliminar")]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c77f0a70","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/v_cirugia_form.vue
// module id = 239
// module chunks = 1